module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"t1":"Initial Public Offering","t2":"Subscription Period","t3":"20-28 November, 2023","msg1":"Dubai Taxi Initial Public Offering"},"ar":{"t1":"الــطــرح الــعــام الأولـي","t2":"فترة الاكتتاب","t3":"20-28 نوفمبر 2023","msg1":"الاكتتاب العام الأولي لشركة تاكسي دبي"}}')
  delete Component.options._Ctor
}
